import { Hide, Image, Show } from '@chakra-ui/react';
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '@/assets/magnumbet/images/logo/logo.png';
import logoMb from '@/assets/magnumbet/images/logo/logoMb.png';
import { THEME_NAME } from '@/constants/themeConfig';

export default function index() {
  return (
    <Link to="/">
      <Show above="lg">
        <Image src={logo} alt={THEME_NAME.magnumbet} mx="auto" mb={4} />
      </Show>
      <Hide above="lg">
        <Image src={logoMb} alt={THEME_NAME.magnumbet} h="16" />
      </Hide>
    </Link>
  );
}
